import React from 'react'
import { FormGroup, Typography, ControlFeedback } from '@smooth-ui/core-em'
import { Input, Button, Box, Space } from 'UILibrary'
import { resetPassword } from 'services/api'
import { css } from 'react-emotion'
import { EMAIL_REGEX } from '../../../constants'
import Loader from '../../../components/Loader'

const forgotPasswordDiv = css({
  padding: '15px',
  display: 'block',
})

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      errors: {},
    }
  }

  onFormFieldChange = event => {
    const target = event.target
    const name = target.id
    const value = target.value

    this.setState(state => ({
      [name]: value,
      errors: { ...state.errors, [name]: this.validateField(name, value) },
    }))
  }

  validateField = (name, value) => {
    if (!value) {
      return 'is missing'
    }

    switch (name) {
      case 'email': {
        if (null === value.match(EMAIL_REGEX)) {
          return 'is invalid'
        }
        break
      }
      default:
        break
    }
  }

  handleRequestResetPassword = async () => {
    const { isLoadingStatus } = this.props
    isLoadingStatus(true)
    const { errors } = await resetPassword(this.state.email.trim())
    errors && isLoadingStatus(false)

    if (0 < errors.length) {
      this.props.showFlashMessage(true, `${errors.join(';')}`)
    } else {
      this.props.history.push({ pathname: '/auth/check' })
    }
  }

  render() {
    const { email, errors } = this.state
    const { isLoading } = this.props

    return (
      <span className={forgotPasswordDiv}>
        <Typography variant="h3">Forgot Password</Typography>
        <Space size="xl" />
        <Box>
          <Typography>Enter your registered email address and we'll send a link to reset your password.</Typography>
        </Box>
        <Space size="l" />
        <FormGroup>
          <Input
            id="email"
            type="email"
            control
            placeholder="Your e-mail address"
            value={email}
            onChange={this.onFormFieldChange}
            valid={errors.email ? false : null}
            maxLength="80"
          />
          {errors.email && <ControlFeedback valid={false}>{errors.email}</ControlFeedback>}
        </FormGroup>
        <Button form success onClick={this.handleRequestResetPassword} disabled={!email || errors.email}>
          {isLoading ? <Loader color="white" /> : 'REQUEST RESET'}
        </Button>
        <Space size="s" />
        <Button form back onClick={() => this.props.history.push({ pathname: '/', search: `?signin=true` })}>
          BACK TO LOGIN
        </Button>
      </span>
    )
  }
}

export default ForgotPassword



// WEBPACK FOOTER //
// ./src/features/authentication/components/ForgotPassword.js